import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // This ensures that if you ever use links, it stays at the top
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;